export default {"src":"/_next/static/media/add.d54b5708.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};